class GrindOptions extends HTMLElement {
    constructor() {
        super();
        this.btnEventListeners();
        this.radioBtnOnChange();

        this.selectedCategory = undefined;
        this.selectedSubCategory = undefined;
    }

    btnEventListeners() {
        const grindElements = this.grindComponents();

        grindElements.grindElements.forEach((item) => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                item.querySelector('input').checked = true;
                // this.selectedCategory = item.querySelector('input').value;

                grindElements.grindElements.forEach(item => {
                    item.querySelector('img').removeAttribute('style');
                })

                //Hide all subcategories
                document.querySelectorAll('.grind-guide-exctra-options').forEach(option => {
                    option.classList.add('twcss-hidden');
                    //Uncheck everything
                    option.querySelectorAll('input').forEach(checkbox => {
                        checkbox.checked = false;
                    })
                })
                if(item.dataset.open == 'true') {
                    // item.querySelector('img').style.filter = 'brightness(0) invert(1)';
                    let targetElement = document.querySelector(`#${item.dataset.target}`);
                    if(targetElement.classList.contains('twcss-hidden')) {
                        targetElement.classList.remove('twcss-hidden');
                        targetElement.querySelector('input').checked = true;
                    } else {
                        targetElement.classList.add('twcss-hidden');
                        item.querySelector('input').checked = false;
                    }
                }
            })
        });
    }

    radioBtnOnChange() {
        const { grindElements, allExtraOptionElements } = this.grindComponents();

        grindElements.forEach(element => {
            element.addEventListener('click', () => {
                if(element.querySelector('input').checked) {
                    this.selectedCategory = element.querySelector('input').value;
                    //If selected option contains subcategories
                    if(element.dataset.open) {
                        let subcategories = document.querySelector(`#${element.dataset.target}`);
                        this.selectedSubCategory = subcategories.querySelector('input:checked').value;
                    } else {
                        this.selectedSubCategory = undefined;
                    }
                }
                this.updateProductProperties();
            })
        });

        allExtraOptionElements.forEach(element => {
            element.addEventListener('click', () => {
                if(element.querySelector('input').checked) {
                    this.selectedSubCategory = element.querySelector('input').value;
                }
                this.updateProductProperties();
            })
        })
    }

    updateProductProperties() {
        const { grindBuyNowProp } = this.grindComponents();

        let grindProperty = `${ this.selectedCategory }`;
        if(this.selectedSubCategory != undefined) {
            grindProperty = `${ this.selectedCategory } -> ${ this.selectedSubCategory }`;
        }
        grindBuyNowProp.value = grindProperty;

    }

    grindComponents() {
        const grindElements = this.querySelectorAll('.grind-option-element');
        const extraOptions = this.querySelector('.grind-guide-exctra-options');
        const allExtraOptionElements = this.querySelectorAll('.grind-guide-extra-input');
        const grindBuyNowProp = document.getElementById('product-buyNow-form-grind');

        return { grindElements, extraOptions, allExtraOptionElements, grindBuyNowProp }
    }
}

customElements.define("grind-options", GrindOptions);
